import React, { Fragment } from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Card } from 'reactstrap';
import { scaleProductFor50L } from '~/utils/products';
import { calculateTotals } from '~/utils/ingredients';

const ProductSummaryCard = ({ className, product }) => {
  const { abv, lotPrefix, customsName, hsCode, costPerLitre } = product;
  const scaledProduct = scaleProductFor50L(product);
  const { grain, hops } = calculateTotals(scaledProduct.ingredients);
  return (
    <Card className={cn(className, 'pa3')}>
      <h3 className="f4 mt0">Summary</h3>
      {customsName &&
        customsName.length && (
          <Fragment>
            <h4 className="table-header mv0">Name for customs report</h4>
            <p>{customsName}</p>
          </Fragment>
        )}
      {hsCode && (
        <Fragment>
          <h4 className="table-header mv0">HS Code</h4>
          <p>{hsCode.name}</p>
        </Fragment>
      )}
      <h4 className="table-header mv0">Ingredient cost per litre</h4>
      <p>${costPerLitre}</p>

      {/* <h4 className="table-header mv0">Kegs on hand</h4>
      <p>3</p>
      <h4 className="table-header mv0">Bottles on hand</h4>
      <p>30 doz</p> */}
      <h4 className="table-header mv0">Customs reports</h4>
      <p>
        Prefix of <strong>{lotPrefix}</strong>
      </p>
      <h4 className="table-header mv0">Alcohol</h4>
      <p>{abv}% ABV</p>
      <h4 className="table-header mv0">Ingredients per 50L</h4>
      <p>
        {grain.amount} {grain.measurementType.toLowerCase()} malt
      </p>
      <p>
        {hops.amount} {hops.measurementType.toLowerCase()} hops
      </p>
      {product.mostRecentLot && (
        <Fragment>
          <h4 className="table-header mv0">Most recent lot</h4>
          <p>{moment(product.mostRecentLot.completedAt).format('ddd Do MMM')}</p>
        </Fragment>
      )}
      {/*
      <h4 className="table-header mv0">Next scheduled lot</h4>
      <p>2nd September, 2018</p> */}
    </Card>
  );
};

export default ProductSummaryCard;



// WEBPACK FOOTER //
// ./src/components/productSummaryCard/productSummaryCard.jsx